import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import CartDrawer from "./components/CartDrawer";
import ProtectedRoute from "./components/ProtectedRoute";

// Customer Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import FutureProducts from "./pages/FutureProducts";
import Contact from "./pages/Contact";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminCategories from "./pages/admin/AdminCategories";

function App() {
  return (
    <div className="App">
      <Router>
        <AuthProvider>
          <CartProvider>
            <Routes>
              {/* Customer Routes */}
              <Route path="/" element={
                <>
                  <Header />
                  <Home />
                  <Footer />
                  <WhatsAppButton />
                  <CartDrawer />
                </>
              } />
              <Route path="/about" element={
                <>
                  <Header />
                  <About />
                  <Footer />
                  <WhatsAppButton />
                  <CartDrawer />
                </>
              } />
              <Route path="/products" element={
                <>
                  <Header />
                  <Products />
                  <Footer />
                  <WhatsAppButton />
                  <CartDrawer />
                </>
              } />
              <Route path="/future-products" element={
                <>
                  <Header />
                  <FutureProducts />
                  <Footer />
                  <WhatsAppButton />
                  <CartDrawer />
                </>
              } />
              <Route path="/contact" element={
                <>
                  <Header />
                  <Contact />
                  <Footer />
                  <WhatsAppButton />
                  <CartDrawer />
                </>
              } />
              <Route path="/shop" element={
                <>
                  <Shop />
                  <WhatsAppButton />
                  <CartDrawer />
                </>
              } />
              <Route path="/product/:slug" element={
                <>
                  <ProductDetail />
                  <WhatsAppButton />
                  <CartDrawer />
                </>
              } />
              <Route path="/cart" element={
                <>
                  <Cart />
                  <WhatsAppButton />
                  <CartDrawer />
                </>
              } />
              <Route path="/checkout" element={
                <>
                  <Checkout />
                  <WhatsAppButton />
                </>
              } />

              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin/products" element={
                <ProtectedRoute>
                  <AdminProducts />
                </ProtectedRoute>
              } />
              <Route path="/admin/categories" element={
                <ProtectedRoute>
                  <AdminCategories />
                </ProtectedRoute>
              } />
              <Route path="/admin/orders" element={
                <ProtectedRoute>
                  <AdminOrders />
                </ProtectedRoute>
              } />
            </Routes>
          </CartProvider>
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;